import { Info, InfoOutlined, Inventory2Outlined, ListAlt } from '@mui/icons-material';
import { Alert, BottomNavigation, BottomNavigationAction, Box, Paper, Typography } from '@mui/material';
import { AppModels, BottomNavigationSection, ScanModeViewMode } from 'cdx-common';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useHashParams } from '../../libraries/hashParams';
import { AppItem } from '../AppItems';



export const MobileScanModeLayout = (props: {
    topChildren: React.ReactNode;
    mainChildren: React.ReactNode;
}) => {

    const hashParams = useHashParams();
    const [searchParams] = useSearchParams();
    const mode = hashParams.get('mode') as ScanModeViewMode | null;
    const type = searchParams.get('type') as AppModels || null;
    const id = searchParams.get('id') as ModelId | null;

    const onInfoClick = () => {
        hashParams.set('mode', ScanModeViewMode.DETAILS);
    };
    const onInventoryClick = () => {
        hashParams.set('mode', ScanModeViewMode.INVENTORY);
    };
    const onListClick = () => {
        hashParams.set('mode', ScanModeViewMode.LIST);
    };

    const WarningPopup = (): React.ReactNode => {
        return mode === ScanModeViewMode.LIST && type && id && [AppModels.warehouses, AppModels.users].includes(type as AppModels) ? <Box sx={{ textAlign: 'center' }}>
            <Alert icon={<Info fontSize="inherit" />} severity="info">
                <Typography component='div'>Sélection : <strong><AppItem mode='text' type={type as AppModels} id={id} /></strong></Typography>
            </Alert>
        </Box> : null;
    };

    return <Box sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        bgcolor: 'background.default'
    }}>
        <Box sx={{
            minHeight: 40,
            display: 'flex',
            alignItems: 'center',
            px: 1,
            flexShrink: 0
        }}>
            {props.topChildren}
        </Box>
        <Box component="main" sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
            {props.mainChildren}
        </Box>
        <WarningPopup />
        <Paper
            component="nav"
            aria-label="Navigation du lecteur de code-barres"
            square
            elevation={8}
            sx={{ flexShrink: 0, pb: 'env(safe-area-inset-bottom)' }}
        >
            <BottomNavigation showLabels value={(mode === ScanModeViewMode.DETAILS || mode === ScanModeViewMode.EDIT_SUBJECT) ? BottomNavigationSection.details : (mode === ScanModeViewMode.INVENTORY ? BottomNavigationSection.inventory : BottomNavigationSection.list)}>
                <BottomNavigationAction onClick={onListClick} label="Liste" value="list" icon={<ListAlt />} />
                <BottomNavigationAction disabled={!searchParams.get('id')} onClick={onInfoClick} label="Détail" value="details" icon={<InfoOutlined />} />
                <BottomNavigationAction disabled={!hashParams.get('inventoryId')} onClick={onInventoryClick} label="Inventaire" value="inventory" icon={<Inventory2Outlined />} />
            </BottomNavigation>
        </Paper>
    </Box>;
};
